import { GridPinnedColumnFields } from '@microservices/wiskey-react-table-component'

import { ConfiguredColumn } from '@types'

export const getPinnedColumns = (columns: ConfiguredColumn[]) => {
  const data: GridPinnedColumnFields = { left: [], right: [] }

  columns.forEach(item => {
    if (item.pinnedColumn) {
      data[item.pinnedColumn]?.push(item.code)
    }
  })

  return data
}
